import { Component, ComponentRef, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AgendaService } from 'src/app/services/agenda/agenda.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { EventStatus } from 'src/app/utils/interfaces/new/event-status.interface';
import { EventType } from 'src/app/utils/interfaces/new/event-type.interface';
import { Event } from 'src/app/utils/interfaces/old/agenda-interface';
import * as moment from 'moment';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { RessourceCreationRendezVous } from 'src/app/utils/interfaces/new/RessourceCreationRendezVous';
import { EventResource } from 'src/app/utils/interfaces/new/event-resource.interface';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientService } from 'src/app/services/patient/patient.service';
import { Subscription } from 'rxjs';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { LoadingModalFragment } from 'src/app/fragments/modal/loading/loading-modal.fragment';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { SafeHtmlUtils } from 'src/app/utils/safe-html.util';

interface PatientConsultationTableDisplay {
  id: string;
  date: Date | string;
  heure: string;
  toPlan: string;
  status: string;
  type: string;
  description: string;
  patient: string;
  resources: string;
  createdAt: string;
  createdBy: string;
}
@Component({
  selector: 'app-event-search',
  templateUrl: './event-search.component.html',
  styleUrls: ['./event-search.component.scss']
})
export class EventSearchComponent implements OnInit {

  public dateMask = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  };

  public accountName = 'Docteur Renaud';

  public formGroup: FormGroup;
  public statusList: Array<EventStatus> = [];
  public resources: Array<EventResource> = [];
  public eventTypes: Array<EventType> = [];
  public numberItemPerPage = 30;
  public searchResult: Paginated<PatientConsultationTableDisplay>;
  public sortOrder: SortEnum.ASC;
  public sortBy = 'dateDebut';
  public SelectedPatient: boolean = false;
  private patient: any;
  private patientChangeSub: Subscription;
  private statusChangeSub: Subscription;
  private typeChangeSub: Subscription;
  private isPrinting = false;
  public patientEventsColumnTable = [
    { title: 'Date', data: 'date' },
    { title: 'Heure', data: 'heure' },
    { title: 'A planifier', data: 'toPlan' },
    { title: 'Statut', data: 'status' },
    { title: 'Description', data: 'description' },
    { title: 'Patient', data: 'patient' },
    { title: 'Ressource(s)', data: 'resources' },
    { title: 'Créé le', data: 'createdAt' },
    { title: 'Créé par', data: 'createdBy' }
  ];

  public customTimePickerTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: 'var(--white)',
    },
    dial: {
      dialBackgroundColor: 'var(--primary)',
    },
    clockFace: {
      clockFaceBackgroundColor: 'var(--box-shadow-grey)',
      clockHandColor: 'var(--primary)',
      clockFaceTimeInactiveColor: 'var(--white)'
    }
  };

  // TODO Ces listes de label devraient disparaître lorsque le fragment form-input acceptera plus seulement des tableaux de string en paramètre
  public statusLabelList: Array<string> = ['Vider'];
  public resourcesLabel: Array<string> = [];
  public eventTypesLabel: Array<string> = ['Vider'];

  constructor(
    private formBuilder: FormBuilder,
    private agendaSrv: AgendaService,
    private modalSrv: ModalService,
    private viewContainerRef: ViewContainerRef,
    private _send: HeaderCommunicationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private patientSrv: PatientService,
    private _strUtilsSrv: StringUtilsService
  ) {
    const head: Header = {
      isBack: true,
      backPage: "agenda",
      title: "Recherche de rendez-vous"
    };
    this._send.announceHeader(head);
  }

  ngOnInit(): void {
    this.initData();
  }

  ngOnDestroy() {
    if (this.patientChangeSub) {
      this.patientChangeSub.unsubscribe();
    }

    if (this.typeChangeSub) {
      this.typeChangeSub.unsubscribe();
    }

    if (this.statusChangeSub) {
      this.statusChangeSub.unsubscribe();
    }

    this.agendaSrv.doRemoveNavigationParams();
  }

  private async initData(): Promise<void> {
    const loading = this.modalSrv.openLoading(this.viewContainerRef);
    try {
      this.statusList = await this.getStatusList();
      this.resources = await this.getResources();
      this.eventTypes = await this.getEventTypes();

      // TODO A RETIRER / Ces itération sauvages devraient disparaître lorsque le fragment form-input acceptera plus seulement des tableaux de string en paramètre
      for (const status of this.statusList) {
        this.statusLabelList.push(status.label);
      }

      for (const r of this.resources) {
        this.resourcesLabel.push(r.nom);
      }

      for (const r of this.eventTypes) {
        this.eventTypesLabel.push(r.label);
      }
      // A RETIRER FIN

      const patientId = this.activatedRoute.snapshot.queryParamMap.get('patientId');
      let patient = '';
      if (patientId) {
        this.patient = await this.patientSrv.findOnePatientInfos(patientId);
        patient = `${this.patient.nom} ${this._strUtilsSrv.uppercaseFirstCharString(this.patient.prenom)}`;
        this.SelectedPatient = true;
      }

      this.formGroup = this.formBuilder.group({
        patient: [patient],
        description: [''],
        type: [''],
        resource: [[]],
        dateStart: [new Date()],
        dateEnd: [new Date()],
        timeStart: [''],
        timeEnd: [''],
        status: [''],
        withoutPatientOnly: [false],
        unplannedEventsOnly: [false]
      });

      this.patientChangeSub = this.formGroup.get('patient').valueChanges.subscribe((value) => {
        if (value === '') {
          this.patient = undefined;
        }
      });

      this.formGroup.get('dateStart').setValidators([Validators.required, Validators.minLength(0)]);

      this.statusChangeSub = this.formGroup.get('status').valueChanges.subscribe((value) => {
        if (value === 'Vider') {
          this.formGroup.get('status').patchValue('');
        }
      });

      this.typeChangeSub = this.formGroup.get('type').valueChanges.subscribe((value) => {
        if (value === 'Vider') {
          this.formGroup.get('type').patchValue('');
        }
      });
    } catch (e) {
      this._showAlert();
    } finally {
      this.modalSrv.close(loading);
    }
  }

  public async getLastPatient() {
    try {
      const lastPatient = await this.patientSrv.findLastPatient();
      let patient = '';
      if (lastPatient && lastPatient.id) {
        this.patient = await this.patientSrv.findOnePatientInfos(lastPatient.id);
        patient = `${this.patient.nom} ${this.patient.prenom}`;
      } else {
        return;
      }

      this.formGroup = this.formBuilder.group({
        patient: [patient],
        description: [''],
        type: [''],
        resource: [[]],
        dateStart: [''],
        dateEnd: [''],
        timeStart: [''],
        timeEnd: [''],
        status: [''],
        withoutPatientOnly: [false],
        unplannedEventsOnly: [false]
      });

      this.patientChangeSub = this.formGroup.get('patient').valueChanges.subscribe((value) => {
        if (value === '') {
          this.patient = undefined;
        }
      });
    } catch (e) {
      this._showAlert('Une erreur est survenue lors de la récupération du dernier patient');
    }
  }

  public async openPatientSearch() {
    await this.router.navigateByUrl(this.router.createUrlTree(['/user/patient'], { queryParams: { navigateToEventSearch: true } }));
  }

  public async doSearchEvents(page = 1) {
    let loading: ComponentRef<LoadingModalFragment>;

    try {
      // Controle de surface sur la date
      if (moment(this.formGroup.get('dateStart').value).isAfter(moment(this.formGroup.get('dateEnd').value))) {
        this.modalSrv.openAlert(this.viewContainerRef, 'Erreur de saisie', 'La date de commencement doit être inférieure à la date de fin');
        return;
      }

      // Controle de surface sur l'heure
      if (moment(this.formGroup.get('timeStart').value, 'kk:mm').isAfter(moment(this.formGroup.get('timeEnd').value, 'kk:mm'))) {
        this.modalSrv.openAlert(this.viewContainerRef, 'Erreur de saisie', 'L\'heure de commencement doit être inférieure à l\'heure de fin');
        return;
      }

      loading = this.modalSrv.openLoading(this.viewContainerRef);

      // Get statusID
      let status: EventStatus | undefined = undefined;
      if (this.formGroup.get('status').value !== '') {
        status = this.statusList.find(s => s.label === this.formGroup.get('status').value);
      }

      // TODO Get patientId !! fait dans this.patient.id!!

      // Get typeId
      let type: EventType | undefined = undefined;
      if (this.formGroup.get('type').value !== '') {
        type = this.eventTypes.find(t => t.label === this.formGroup.get('type').value);
      }

      // Get resourcesId
      const resources: Array<RessourceCreationRendezVous> = []
      for (const r of this.resources) {
        if ((this.formGroup.get('resource').value as Array<string>).includes(r.nom)) {
          resources.push({
            id: r.id,
            type: r.superType
          });
        }
      }

      const eventsPaginated = await this.agendaSrv.searchEvents(
        page,
        this.patient ? this.patient.id : undefined,
        this.formGroup.get('description').value,
        type ? type.id : undefined,
        resources.length > 0 ? resources : undefined,
        this.formGroup.get('dateStart').value,
        this.formGroup.get('dateEnd').value,
        this.formGroup.get('timeStart').value,
        this.formGroup.get('timeEnd').value,
        status ? status.id : undefined,
        this.formGroup.get('withoutPatientOnly').value,
        this.formGroup.get('unplannedEventsOnly').value,
        this.numberItemPerPage,
        this.sortOrder,
        this.sortBy
      );

      this.setSearchResult(eventsPaginated);

    } catch (e) {
      this._showAlert('Une erreur est survenue lors de la recherche de rendez-vous');
    } finally {
      if (loading) {
        this.modalSrv.close(loading);
      }
    }
  }
  public onDeletePatient(){
    this.patient  = undefined;
    this.formGroup.get('patient')?.setValue("");
    this.SelectedPatient = false;
  }

  private setSearchResult(events: Paginated<Event>) {
    const eventTmp: Array<PatientConsultationTableDisplay> = [];
    for (const e of events.objects) {
      const resources = [];
      for (const r of e.ressourses) {
        resources.push(r.nom);
      }

      eventTmp.push({
        id: e.id,
        createdAt: moment(e.createdAt).format('DD/MM/YYYY'),
        createdBy: e.createdBy.nom,
        date: e.dateDebut ? e.dateDebut : '',
        description: e.description ? e.description : '',
        heure: e.dateDebut ? moment(e.dateDebut).format('HH:mm') : '',
        patient: e.patient ? e.patient.nom + ' ' + this._strUtilsSrv.uppercaseFirstCharString(e.patient.prenom)+' (' + this.frDate(e.patient.dateNaissance) + ')' : '',
        resources: resources.join('\r\n'),
        status: e.status ? e.status.label : '-',
        toPlan: e.planifie ? 'Non' : 'Oui',
        type: e.type ? e.type.label : ''
      });
    }

    if (this.searchResult) {
      this.searchResult.objects = [...eventTmp];
      this.searchResult.page = events.page;
      this.searchResult.perpage = events.perpage;
      this.searchResult.total = events.total;
    } else {
      this.searchResult = {
        objects: [...eventTmp],
        page: events.page,
        perpage: events.perpage,
        total: events.total,
      }
    }
  }

  public async onSort(event: any): Promise<void> {
    this.sortOrder = event.sortOrder;
    this.sortBy = event.sortBy;
    this.doSearchEvents();
  }

  public async goToEventDetails(event: PatientConsultationTableDisplay): Promise<void> {
    this.router.navigateByUrl(`/user/agenda/update/${event.id}`);
  }

  public timeChanged(event: string, control: string): void {
    this.formGroup.get(control).patchValue(event);
  }

  private async getStatusList(): Promise<Array<EventStatus>> {
    return await this.agendaSrv.getStatus();
  }

  private async getResources(): Promise<Array<EventResource>> {
    const resources = await this.agendaSrv.getResources();
    return resources;
  }

  private async getEventTypes(): Promise<Array<EventType>> {
    return await this.agendaSrv.getEventTypes();
  }

  private _showAlert(msg?: string): void {
    msg = msg ? msg : 'Une erreur est survenue lors de la récupération des informations de cette page';

    this.modalSrv.openAlert(this.viewContainerRef, 'Erreur', msg);
  }

  public async doPrintSearchResults(): Promise<void> {
    if (this.isPrinting) return;
    this.isPrinting = true;
    const loadingRef = this.modalSrv.openLoading(this.viewContainerRef);

    try {
      const src = this.searchResult?.objects ?? [];
      if (!src.length) {
        //this._snack.openSnackBar('Aucun résultat à imprimer.');
        return;
      }

      const rows = src.map((r: any) => ({
        date: r.date ? this.frDate(r.date) : (r.createdAt ?? ''),
        heure: r.heure ?? '',
        patient: SafeHtmlUtils.escapeHtml(r.patient ?? ''),
        //statut: r.status ?? '-',
        type: r.type ?? '',
        description: SafeHtmlUtils.escapeHtml(this.normalizeInlineText(r.description, ' - ')),
        ressources: SafeHtmlUtils.escapeHtml(this.normalizeInlineText(r.resources, ' , ')),
      }));

      await this.printViaIframeAsync({
        title: `Impression recherche rdv`,
        landscape: true,
        columns: [
          { label: 'Date',        key: 'date',        align: 'left' ,width:'8%'},
          { label: 'Heure',       key: 'heure',       align: 'left' ,width:'5%'},
          { label: 'Patient',     key: 'patient',    align: 'left' ,width:'25%'},
          //{ label: 'Statut',      key: 'statut',     align: 'left' ,width:'10%'},
          { label: 'Type',        key: 'type',       align: 'left' ,width:'9%'},
          { label: 'Description', key: 'description',align: 'left',width:'35%' },
          { label: 'Ressources',  key: 'ressources', align: 'left',width:'18%' },
        ],
        rows,
        summaryHtml: '',
      });

    } catch (e) {
      console.error('Impression agenda échouée', e);
    } finally {
      loadingRef?.destroy();
      this.isPrinting = false;
    }
  }

  private frDate(d: any): string {
    if (!d) return '';
    const date = (d instanceof Date) ? d : new Date(d);
    if (isNaN(date.getTime())) return String(d);
    return date.toLocaleDateString('fr-FR');
  }

  private normalizeInlineText(value: any, separator = ' - '): string {
    if (value == null) return '';

    return value
      .toString()
      // normalise tous les retours chariot
      .replace(/\r\n|\r|\n+/g, separator)
      // évite " -  - " ou " - - "
      .replace(/\s*-\s*-\s*/g, separator)
      // espaces multiples
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  private async printViaIframeAsync(opts: {
    title: string;
    columns: { label: string; key: string; align?: 'left'|'right'|'center'; width: string }[];
    rows: any[];
    landscape?: boolean;
    summaryHtml?: string;
  }): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const { title, columns, rows, landscape = true, summaryHtml } = opts;

      const ifr = document.createElement('iframe');
      Object.assign(ifr.style, {
        position: 'fixed',
        right: '0',
        bottom: '0',
        width: '0',
        height: '0',
        border: '0'
      });
      document.body.appendChild(ifr);

      const nowStr = new Date().toLocaleString('fr-FR').replace(/'/g, "\\'");

      const css = `
        @page {
          size: ${landscape ? 'A4 landscape' : 'A4 portrait'};
          margin: 12mm;
          @bottom-left  { content: '${nowStr}'; }
          @bottom-center { content: 'HyperMed Online ©™'; }
          @bottom-right { content: counter(page) ' / ' counter(pages); }
        }
        * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        body { font-family: Arial, sans-serif; font-size: 12px; }
        h3 { margin: 0 0 8px; }
        table { width: 100%; border-collapse: collapse; table-layout: fixed;}
        thead { display: table-header-group;background: #f5f5f5; }
        th, td {
          box-sizing: border-box;
          padding: 6px 8px;
          border-bottom: 1px solid #e0e0e0;
          border-top: 1px solid #e0e0e0;
          vertical-align: top;
          overflow-wrap: anywhere;
          word-break: break-word;
        }
          th, td {
            border-right: 1px dashed #999;
          }

          th:last-child,
          td:last-child {
            border-right: none;
          }
        th.left, td.left { text-align: left; }
        th.right, td.right { text-align: right; }
        th.center, td.center { text-align: center; }
        tbody tr:nth-child(odd) { background: #fcfcfc; }
        tr { break-inside: avoid; page-break-inside: avoid; }

        /* Synthèse */
        .summary-table { margin: 8px 0 12px 0; border: 1px solid #ccc; }
        .summary-table thead { background: #f5f5f5; }
        .summary-table th, .summary-table td { border-bottom: 1px solid #ddd; font-weight: 600; }
        .title {
          text-align: center;
          font-weight: bold;
          font-size: 16px;       /* un peu plus gros */
          color: #ff0000;        /* rouge */
          text-decoration: underline;
          margin: 0 0 10px 0;    /* espace sous le titre */
        }
      `;

      const colgroup = `
        <colgroup>
          ${columns.map(c => `<col style="width:${c.width};">`).join('')}
        </colgroup>
      `;

      const thead = `
        <thead><tr>
          ${columns.map(c => {
            const cls = c.align ? ` class="${c.align}"` : '';
            return `<th${cls}>${c.label}</th>`;
          }).join('')}
        </tr></thead>
      `;



      const tbody = `
        <tbody>
          ${rows.map(r => `
            <tr>
              ${columns.map(c => {
                const v = r[c.key] ?? '';
                const cls = c.align ? ` class="${c.align}"` : '';
                return `<td${cls}>${v}</td>`;
              }).join('')}
            </tr>`).join('')}
        </tbody>
      `;

      const summaryTable = summaryHtml ?? `
        <table class="summary-table">
          <thead><tr><th>Nombre de lignes</th></tr></thead>
          <tbody><tr><td class="center">${rows.length}</td></tr></tbody>
        </table>
      `;

      // Paged.js (si vous l’avez déjà dans assets comme pour factures)
      const pagedSrc = `${location.origin}/assets/pagedjs/paged.polyfill.js`;

      const html = `<!doctype html>
  <html><head>
    <meta charset="utf-8">
    <title>${title}</title>
    <style>${css}</style>
  </head>
  <body>
    <h3  class="title">${title} (${rows.length} rdv)</h3>
    ${summaryTable}
    <table>${colgroup}${thead}${tbody}</table>

    <script>
      let printed = false;
      const fallback = setTimeout(() => {
        if (!printed) {
          printed = true;
          try { parent.postMessage({type:'PRINT_START'}, '*'); } catch(e){}
          window.focus(); window.print();
          try { parent.postMessage({type:'CLEANUP_IFR'}, '*'); } catch(e){}
        }
      }, 1500);

      document.addEventListener('pagedjs:rendered', () => {
        if (!printed) {
          printed = true;
          clearTimeout(fallback);
          try { parent.postMessage({type:'PRINT_START'}, '*'); } catch(e){}
          setTimeout(() => {
            window.focus(); window.print();
            try { parent.postMessage({type:'CLEANUP_IFR'}, '*'); } catch(e){}
          }, 50);
        }
      });
    </script>
    <script src="${pagedSrc}"></script>
  </body></html>`;

      const doc = ifr.contentDocument || ifr.contentWindow?.document;
      if (!doc) {
        document.body.removeChild(ifr);
        reject(new Error('Impossible de créer le document d’impression'));
        return;
      }

      doc.open(); doc.write(html); doc.close();

      const onMsg = (e: MessageEvent) => {
        if (e?.data?.type === 'PRINT_START') resolve();
        if (e?.data?.type === 'CLEANUP_IFR') {
          window.removeEventListener('message', onMsg);
          setTimeout(() => {
            try { document.body.removeChild(ifr); } catch {}
          }, 100);
        }
      };
      window.addEventListener('message', onMsg);
    });
  }
}
